import { Button, Grid, Typography } from "../../../components";
import { formatPrice } from "../../../utils";

const PdvTotalizadores = ({ venda, handleSubmit }) => {
  const valorRestante = (venda?.totalVenda || 0) - (venda.totalPagamentos || 0);
  return (
    <Grid container className="table-pdv-footer p-4 gap-1" fullWidth>
      <Grid container spacing={2}>
        <Grid
          item
          xs={6}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="table-pdv-footer-label">Total de Itens:</p>
          <p className="table-pdv-footer-label">
            {formatPrice(venda.totalMercadoria || 0)}
          </p>
        </Grid>
        <Grid
          item
          xs={6}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="table-pdv-footer-label">
            {valorRestante >= 0 ? "Saldo a pagar: " : "Troco:"}
          </p>
          <p className="table-pdv-footer-label">
            {formatPrice(
              valorRestante >= 0 ? valorRestante : valorRestante * -1
            )}
          </p>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          item
          xs={6}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="table-pdv-footer-label">Desconto:</p>
          <p className="table-pdv-footer-label">
            {formatPrice(venda.desconto || 0)}
          </p>
        </Grid>
        <Grid
          item
          xs={6}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="table-pdv-footer-label">Valor pago:</p>
          <p className="table-pdv-footer-label">
            {formatPrice(venda?.totalPagamentos || 0)}
          </p>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          item
          xs={6}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="table-pdv-footer-label">Acréscimo:</p>
          <p className="table-pdv-footer-label">
            {formatPrice(venda?.despesas || 0)}
          </p>
        </Grid>
        <Grid
          item
          xs={6}
          className="d-flex align-items-center justify-content-between"
        >
          <p className="table-pdv-footer-label">Total:</p>
          <Typography
            variant="h2"
            className="text-black"
            style={{ fontWeight: 700 }}
          >
            {formatPrice(venda?.totalVenda || 0)}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Button
          id="submitFinalizarVenda"
          variant="contained"
          fullWidth
          onClick={handleSubmit}
          color="success"
          sx={{
            p: "0.5rem",
            mt: "0.5rem",
            fontSize: 18,
            boxShadow: 0,
            fontWeight: 800,
          }}
        >
          FINALIZAR VENDA
        </Button>
      </Grid>
    </Grid>
  );
};

export default PdvTotalizadores;
